module.exports = __webpack_public_path__ + "media/components/country-flag/static/cf-c35e74c6a0abd3d6a2fcf0a00b02ddfc.svg";